export const RESTORE_URL_TYPE = {
  SELECT: 'SELECT',
  NEW: 'NEW',
};
